export default "__VITE_ASSET__CEu9npQG__"